function checkMobile(s, type) {
  var length = s.length;

  if (type == 852 || type == 853) {
    if (length == 8) {
      return false
    }
  } else {
    if (length == 11 && /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(14[0-9]{1})|)+\d{8})$/.test(s)) {
      return false
    } else { }
  }
  return true;
}


function checkLanguage(code) {
  var text = ''
  switch (code) {
    case 'Chinese':
      text = "普通話" //'普通話'
      break;
    // case 'Cantonesesss': //Cantonese   暫時註釋不顯示
    //   text = langText("UTILS_LANG.lang1") //'廣東話'
    //   break;
    // case 'Cantonese': //Cantonese   暫時註釋不顯示
    //   text = langText("UTILS_LANG.lang1") //'廣東話'
    //   break;
    case 'English':
      text = "英語" //'英語'
      break;
  }

  return text
}

function splitUrl(str, key) {
  let arr = str.split('&')
  let val = ''
  console.log('arr', arr);

  for (let index = 0; index < arr.length; index++) {
    var v = arr[index];

    if (v.indexOf(key) != -1) {
      console.log('v', v, v.split(key)[1], decodeURI(v.split(key)[1]));
      return decodeURI(v.split(key)[1])
    }

  }

}

function timeSplit(value) {

  if (value.indexOf("天") > -1) {
    // let time = new Date();
    // let yy = time.getFullYear();
    // let mm = time.getMonth() + 1;
    // let dd = time.getDate();
    // let timeArray = value.split('有效期');
    // let timeNumber = timeArray[1].split('天')[0];
    // mm = mm < 10 ? '0' + mm : mm;
    // dd = dd < 10 ? '0' + dd : dd;
    // let startTime = yy + "/" + mm + "/" + dd;

    // let endTime = new Date((new Date(startTime).getTime()) + (timeNumber * 86400000));
    // let endYY = endTime.getFullYear();
    // let endMM = endTime.getMonth() + 1;
    // let endDD = endTime.getDate();
    // endMM = endMM < 10 ? '0' + endMM : endMM;
    // endDD = endDD < 10 ? '0' + endDD : endDD;
    // // console.log(timeNumber,yy,mm,dd,endYY,endMM,endDD)
    // return yy + "." + mm + "." + dd + " - " + endYY + "." + endMM + "." + endDD;
    return value
  } else {
    let time = value.split('-');
    return time[0] + "." + time[1] + "." + time[2] + " - " + time[3] + "." + time[4] + "." + time[5]
  }
}
function formatPrice(price) {
  if (price == undefined) {
    return null
  }
  let yuan = parseInt(price / 100)
  let cen = price % 100;
  let pStr = yuan
  pStr += cen > 0 ? ('.' + cen) : ''
  return pStr;
}
//半角转化全角
function toDash(txtstring) {

  if (!txtstring) {
    return
  }


  let textArr = txtstring.split('')

  for (var i = 0; i < txtstring.length; i++) {

    if (textArr[i] == '—') {
      textArr[i] = '─'
    }
  }

  return textArr.join('');
}
function formatDurationSimple(duration) {

  if (duration === undefined || duration === null) {
    return ''
  }
  let h = parseInt(duration / 3600)
  let m = parseInt(duration / 60)
  let s = duration % 60
  let str = '';
  str += h > 0 ? (h + ':') : ''
  str += m >= 0 ? ((m < 10 ? "0" + m : (m)) + ':') : '00'
  str += s > 0 ? (s < 10 ? "0" + s : (s)) : '00'

  return str;
}

function chackNative() {
  //检测native环境
  var isNative = ''
  try {
    //native环境
    // console.log('test ntive', native);
    native.getDeviceInfo();
    // console.log('chack is native');
    // Vue.prototype.NATIVEDATA = JSON.parse(native.getDeviceInfo());
    // Vue.prototype.ccIsNative = true;
    // this.GLOBAL_.ccRequest.setNative(JSON.parse(native.getDeviceInfo()));
    return true
  } catch (error) {
    // console.log(error);

    // console.log("chack 沒有native運行時環境utils！");
    return false
  }
}

export default {
  checkMobile,
  timeSplit,
  splitUrl,
  checkLanguage,
  formatPrice,
  toDash,
  formatDurationSimple,
  chackNative,
}



// WEBPACK FOOTER //
// ./src/utils/utils.js